import ExternalPlan from 'Classes/ExternalPlan';

const typeInfo = [
  {
    class: ExternalPlan,
    type: 'external',
    label: 'External Plan',
    iconSrc: '',
  },
];

function getByLabel(label) {
  const types = typeInfo.filter(info => info.label === label);
  if (types.length === 0) {
    throw new Error(`${label} was not a valid label.`);
  }
  if (types.length > 1) {
    throw new Error(`Should not be possible. Label was: ${label}`);
  }
  return types[0].type;
}

function getClass(planType) {
  const types = typeInfo.filter(info => info.type === planType);
  if (types.length === 0) {
    throw new Error(`${planType} was not a valid plan type.`);
  }
  if (types.length > 1) {
    throw new Error(`Should not be possible. Plan type was: ${planType}`);
  }
  return types[0].class;
}

function getIconSrc(planType) {
  const types = typeInfo.filter(info => info.type === planType);
  if (types.length === 0) {
    throw new Error(`${planType} was not a valid plan type.`);
  }
  if (types.length > 1) {
    throw new Error(`Should not be possible. Plan type was: ${planType}`);
  }
  return types[0].iconSrc;
}

function getLabel(planType) {
  const types = typeInfo.filter(info => info.type === planType);
  if (types.length === 0) {
    throw new Error(`${planType} was not a valid plan type.`);
  }
  if (types.length > 1) {
    throw new Error(`Should not be possible. Plan type was: ${planType}`);
  }
  return types[0].label;
}

export {
  getByLabel, getClass, getIconSrc, getLabel,
};
